var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.667 10C1.667 5.4 5.4 1.667 10 1.667S18.333 5.4 18.333 10 14.6 18.333 10 18.333A8.336 8.336 0 0 1 1.667 10c0-3.067 0-3.067 0 0zm9.166 3.333V15H9.167v-1.667h1.666zM10 16.667A6.676 6.676 0 0 1 3.333 10 6.676 6.676 0 0 1 10 3.333 6.676 6.676 0 0 1 16.667 10 6.676 6.676 0 0 1 10 16.667c-2.45 0-2.45 0 0 0zM6.667 8.333a3.332 3.332 0 1 1 6.666 0c0 1.07-.658 1.645-1.299 2.205-.608.531-1.2 1.05-1.2 1.962H9.166c0-1.518.785-2.12 1.475-2.649.542-.415 1.025-.785 1.025-1.518 0-.916-.75-1.666-1.667-1.666s-1.667.75-1.667 1.666H6.667c0-1.227 0-1.227 0 0z",
    fill: "#1D1D22",
    mask: "url(#b)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.0dd2a0bb14bb296363f68957a5c983bd.svg";
export { ForwardRef as ReactComponent };